function focusStyles(theme) {
  return function () {
    return {
      WebkitTapHighlightColor: "transparent",
      "&:focus": {
        outline: "none",
        boxShadow: theme.focusRing === "always" || theme.focusRing === "auto" ? "0 0 0 2px ".concat(theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white, ", 0 0 0 4px ").concat(theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]) : void 0
      },
      "&:focus:not(:focus-visible)": {
        boxShadow: theme.focusRing === "auto" || theme.focusRing === "never" ? "none" : void 0
      }
    };
  };
}

export { focusStyles };